@if (userService.notToken()) {
	<div
		class="alert alert-primary content-alert"
		role="alert"
	>
		<i
			class="bi bi-shield-exclamation"
			style="margin-right: 10px"
		></i>
		Conferma la mail di registrazione prima di iniziare
	</div>
}
@if (registerCompleted()) {
	<div
		class="alert alert-success content-alert"
		role="alert"
	>
		<i
			class="bi bi-check-lg"
			style="margin-right: 10px"
		></i>
		Registrazione avvenuta con successo! Effettua il Login
	</div>
}
@if (registerTokenNotFound()) {
	<div
		class="alert alert-danger content-alert"
		role="alert"
	>
		<i
			class="bi bi-x-octagon"
			style="margin-right: 10px"
		></i>
		Registrazione scaduta.
	</div>
}
<app-navbar></app-navbar>
<div class="content">
	<app-spinner></app-spinner>
	@if(!reload()){
		<router-outlet></router-outlet> 
	}
</div>
<app-footer></app-footer>
